export type OkrType = "company" | "department" | "individual"

/**
 * What each level of the OKR tree is called on screen.
 *
 * The bulk-upload flow is shared by all three levels, so the copy has to follow the level it was
 * opened from — an individual upload sends key results to `employeekeyresulttemplate`, and calling
 * them objectives there names the wrong thing.
 */
export const okrLabels: Record<
  OkrType,
  { singular: string; plural: string; lower: string }
> = {
  company: { singular: "Goal", plural: "Goals", lower: "goals" },
  department: {
    singular: "Objective",
    plural: "Objectives",
    lower: "objectives",
  },
  individual: {
    singular: "Key Result",
    plural: "Key Results",
    lower: "key results",
  },
}
